export const isMappedImportField = (field) => {
    return field && field.xlsx_col_index !== undefined && field.xlsx_col_index !== null && Number(field.xlsx_col_index) >= 0;
};

export const MAPPED_EMPTY_FIELDS_KEY = '__ante_import_mapped_empty_fields';

export const resolveImportClearField = (mapping, configField) => {
    if (mapping && mapping.clearEmptyField !== undefined) return mapping.clearEmptyField;
    if (!configField) return null;
    return (mapping && mapping.cnfField) || (mapping && mapping.name) || configField.dataField || configField.field || null;
};

const isEmptyImportValue = (value) => {
    return value === undefined || value === null || (typeof value === 'string' && value.trim() === '');
};

const getMappedEmptyFields = (fileRow, mappedFields) => {
    const source = fileRow instanceof Array ? fileRow : [];
    const fields = (mappedFields || [])
        .filter((field) => {
            if (!isMappedImportField(field) || field.preserveEmptyOnUpdate === true || field.canUpdate === false) return false;
            if (Object.prototype.hasOwnProperty.call(field, 'clearEmptyField') && !field.clearEmptyField) return false;
            return isEmptyImportValue(source[field.xlsx_col_index]);
        })
        .map((field) => ({
            field,
            target: field.clearEmptyField || field.field_name
        }));

    return fields.filter((item, index) => fields.findIndex((other) => other.target === item.target) === index);
};

export const applyMappedImportEmptyPolicy = (row, fileRow, mappedFields, importMode, activity, keepMarker = false) => {
    const source = fileRow instanceof Array ? fileRow : [];
    const isUpdate = importMode === 'Update' || (importMode === 'CreateUpdate' && activity === 'Update');
    const emptyFields = getMappedEmptyFields(source, mappedFields);

    emptyFields.forEach(({ field, target }) => {
        if (field.field_name !== target) row[field.field_name] = undefined;
        if (isUpdate) row[target] = null;
        else row[target] = undefined;
    });

    if (keepMarker && emptyFields.length > 0) row[MAPPED_EMPTY_FIELDS_KEY] = emptyFields.map((item) => item.target);
    else delete row[MAPPED_EMPTY_FIELDS_KEY];

    return row;
};

export const buildMappedImportRow = (fileRow, mappedFields, rowIndex, importMode, activity) => {
    const row = { row_index: rowIndex };
    const source = fileRow instanceof Array ? fileRow : [];

    (mappedFields || []).forEach((field) => {
        if (!isMappedImportField(field)) return;
        row[field.field_name] = source[field.xlsx_col_index];
    });

    return applyMappedImportEmptyPolicy(row, source, mappedFields, importMode, activity, true);
};
